import { render } from "./mga-total-list.vue?vue&type=template&id=5414bef4&ts=true"
import script from "./mga-total-list.ts?vue&type=script&lang=ts"
export * from "./mga-total-list.ts?vue&type=script&lang=ts"

import "./mga-total-list.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__